// Real cart/variant wiring for the atta-gems-moissanite-studs tier picker.
// product-launches/shared/interactions.js's initTierSelector() only handles
// the presentation layer (price tokens, active-card styling) by design --
// this file is the "CC dev" half: making Add to Cart actually add the
// variant the visitor selected. Ported wholesale from the proven
// pavoi-lobe-lifters build (same template-2-jewelry base, identical
// tier-picker/.tier-radio markup) per the cc-page-clone skill's P0 ATC
// pattern (2026-08-28 incident): a native <form action="/cart/add">
// submission, never fetch('/cart/add.js'); a fresh click and a same-tier
// repeat click make zero AJAX cart calls; only a genuine tier switch makes
// one /cart/clear.js call (retried on failure) before the same form-post add.
//
// Differences from pavoi: VARIANT_MAP/PRODUCT_ID point at the moissanite
// product, and syncPairRows() drives TWO selects per pair row (Cut + Color)
// instead of one, because this product is sold in 6 cuts x 2 colors and the
// operator wants every pair in a bundle independently pickable.
(function () {
  'use strict';

  var VARIANT_MAP = {
    'tier-1': 53975907860787,
    'tier-2': 53975907893555,
    'tier-3': 53975907926323
  };
  var PRODUCT_ID = 10416342729011;
  var TIER_PAIR_COUNT = { 'tier-1': 1, 'tier-2': 2, 'tier-3': 3 };

  // Shipping-protection add-on (Priority Insured Shipping, $4.95) -- added
  // to every order alongside whatever tier the visitor selects, same as
  // every other CC-clone product on this store. Submitted as a second
  // items[1][...] pair on the SAME form-post (verified against this store:
  // /cart/add accepts a bare id/quantity mixed with an items[1][...] pair).
  var SHIPPING_PROTECTION_VARIANT_ID = 53646568128819;

  // Shared literal key across every CC-clone page so cross-product and
  // cross-tab "one product in the cart at a time" tracking works (see the
  // pavoi build notes on why localStorage, not sessionStorage).
  var CART_TRACK_KEY = 'acromActiveCartVariant';

  function getForm() {
    return document.querySelector('form.shopify-product-form');
  }

  function getHiddenIdInput(form) {
    return form ? form.querySelector('input[name="id"]') : null;
  }

  // The captured form's hidden product-id still points at the reference
  // product this markup was captured from; Shopify validates id against
  // product-id and silently drops return_to on a mismatch. Keep in sync.
  function syncProductIdField(form) {
    var input = form ? form.querySelector('input[name="product-id"]') : null;
    if (input) input.value = PRODUCT_ID;
  }

  function ensureReturnToCheckout(form) {
    var input = form.querySelector('input[name="return_to"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'return_to';
      form.appendChild(input);
    }
    input.value = '/checkout';
  }

  function ensureShippingProtectionItem(form) {
    var idInput = form.querySelector('input[name="items[1][id]"]');
    if (!idInput) {
      idInput = document.createElement('input');
      idInput.type = 'hidden';
      idInput.name = 'items[1][id]';
      form.appendChild(idInput);
    }
    idInput.value = SHIPPING_PROTECTION_VARIANT_ID;

    var qtyInput = form.querySelector('input[name="items[1][quantity]"]');
    if (!qtyInput) {
      qtyInput = document.createElement('input');
      qtyInput.type = 'hidden';
      qtyInput.name = 'items[1][quantity]';
      form.appendChild(qtyInput);
    }
    qtyInput.value = '1';
  }

  function getCheckedTierRadio() {
    return document.querySelector('.tier-radio:checked');
  }

  // The per-pair picker block (name="properties[Pair N Cut]" and
  // name="properties[Pair N Color]") is NOT a descendant of the real <form>
  // -- it lives in the buy-box block list -- so every select needs an
  // explicit form= association (HTML attribute, read via getAttribute('id')
  // because <input name="id"> DOM-clobbers form.id). Rows beyond the
  // selected tier's pair count stay hidden AND disabled so they're excluded
  // from submission; the cart/checkout/order then carries exactly one Cut
  // and one Color line-item property per pair actually purchased.
  function syncPairRows() {
    var form = getForm();
    var formId = form ? form.getAttribute('id') : null;
    var radio = getCheckedTierRadio();
    var pairCount = radio ? (TIER_PAIR_COUNT[radio.value] || 1) : 1;
    document.querySelectorAll('.pair-color-row').forEach(function (row) {
      var pairNum = parseInt(row.getAttribute('data-pair'), 10);
      var show = pairNum <= pairCount;
      row.hidden = !show;
      row.querySelectorAll('select').forEach(function (select) {
        select.disabled = !show;
        if (formId && !select.hasAttribute('form')) select.setAttribute('form', formId);
      });
    });
  }

  function getSelectedVariantId() {
    var radio = getCheckedTierRadio();
    if (!radio) return null;
    return VARIANT_MAP[radio.value] || null;
  }

  function syncHiddenIdField() {
    var form = getForm();
    var input = getHiddenIdInput(form);
    var variantId = getSelectedVariantId();
    if (input && variantId) input.value = variantId;
    syncProductIdField(form);
  }

  function getTrackedVariant() {
    try { return localStorage.getItem(CART_TRACK_KEY); } catch (e) { return null; }
  }
  function setTrackedVariant(id) {
    try { localStorage.setItem(CART_TRACK_KEY, String(id)); } catch (e) { /* private mode etc. */ }
  }

  function fetchWithRetry(url, options, retries, delayMs) {
    return fetch(url, options).then(function (res) {
      if (!res.ok && (res.status === 429 || res.status >= 500) && retries > 0) {
        return new Promise(function (resolve) { setTimeout(resolve, delayMs); })
          .then(function () { return fetchWithRetry(url, options, retries - 1, delayMs * 2); });
      }
      return res;
    }, function (err) {
      if (retries > 0) {
        return new Promise(function (resolve) { setTimeout(resolve, delayMs); })
          .then(function () { return fetchWithRetry(url, options, retries - 1, delayMs * 2); });
      }
      throw err;
    });
  }

  function getAtcButtons(form) {
    if (!form) return [];
    // form.id is DOM-clobbered by <input name="id">; read the attribute.
    var formId = form.getAttribute('id');
    var sel = 'buy-buttons[form="' + formId + '"] button[type=submit], button[form="' + formId + '"]';
    var matched = Array.prototype.slice.call(document.querySelectorAll(sel));
    document.querySelectorAll('button[type=submit]').forEach(function (btn) {
      if (btn.form === form && matched.indexOf(btn) === -1) matched.push(btn);
    });
    return matched;
  }

  function setAtcLoading(buttons, loading) {
    buttons.forEach(function (btn) {
      btn.style.pointerEvents = loading ? 'none' : '';
      btn.style.opacity = loading ? '0.6' : '';
      if (loading) {
        btn.dataset.originalHtml = btn.dataset.originalHtml || btn.innerHTML;
        btn.textContent = 'Adding...';
      } else if (btn.dataset.originalHtml) {
        btn.innerHTML = btn.dataset.originalHtml;
      }
    });
  }

  // Restore ATC buttons if the page comes back from bfcache (Back from
  // /checkout) so a button left in "Adding..." isn't stuck.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    setAtcLoading(getAtcButtons(getForm()), false);
  });

  function handleAddToCart(e) {
    e.preventDefault();
    var form = getForm();
    if (!form) return;
    var buttons = getAtcButtons(form);
    var variantId = getSelectedVariantId();
    if (!variantId) {
      alert('Please select an offer above.');
      return;
    }
    var input = getHiddenIdInput(form);
    if (input) input.value = variantId;
    syncProductIdField(form);
    ensureReturnToCheckout(form);
    ensureShippingProtectionItem(form);
    syncPairRows();

    var tracked = getTrackedVariant();
    if (tracked && Number(tracked) === variantId) {
      // Already in cart this session -- straight to checkout, zero cart calls.
      window.location.href = '/checkout';
      return;
    }

    if (!tracked) {
      // Fresh add: native form-post, zero AJAX cart calls.
      setTrackedVariant(variantId);
      setAtcLoading(buttons, true);
      form.submit();
      return;
    }

    // Genuine tier switch: clear the previous line first (one AJAX call,
    // retried), then the same native form-post adds the new one.
    setAtcLoading(buttons, true);
    setTrackedVariant(variantId);
    fetchWithRetry('/cart/clear.js', { method: 'POST' }, 2, 1000)
      .then(function () {
        form.submit();
      })
      .catch(function () {
        setAtcLoading(buttons, false);
        alert('Could not update your cart. Please try again.');
      });
  }

  document.addEventListener('DOMContentLoaded', function () {
    syncHiddenIdField();
    syncPairRows();
    document.querySelectorAll('.tier-radio').forEach(function (radio) {
      radio.addEventListener('change', syncHiddenIdField);
      radio.addEventListener('change', syncPairRows);
    });
    getAtcButtons(getForm()).forEach(function (btn) {
      btn.addEventListener('click', handleAddToCart);
    });
  });
})();
